var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhoneFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#B8BCC8",
  d: "M14.696 21.216a4.89 4.89 0 0 0 6.141-.676l.69-.677a1.66 1.66 0 0 0 0-2.32l-2.93-2.906a1.64 1.64 0 0 0-2.303 0 1.656 1.656 0 0 1-2.319 0L9.37 10.025a1.63 1.63 0 0 1 0-2.322 1.646 1.646 0 0 0 0-2.306L6.45 2.473a1.656 1.656 0 0 0-2.316 0l-.676.692a4.91 4.91 0 0 0-.676 6.149 44.5 44.5 0 0 0 11.914 11.902"
})));
export default SvgPhoneFill;